import { useEffect, useRef, useState } from "react";

const POLL_MS = 5 * 60 * 1000;

async function fetchVersion() {
  const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) throw new Error("no version");
  return (await res.json()).version;
}

// Detects a newly deployed build by polling /version.json and exposes a hard-refresh helper.
export function useAppUpdate() {
  const current = useRef(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const v = await fetchVersion();
        if (!alive) return;
        if (current.current === null) current.current = v;
        else if (v !== current.current) setUpdateAvailable(true);
      } catch {}
    };
    check();
    const id = setInterval(check, POLL_MS);
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { alive = false; clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, []);

  const refresh = async () => {
    try {
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.update().catch(() => {})));
      }
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }
    } finally {
      window.location.reload();
    }
  };

  return { updateAvailable, refresh };
}
